// Instagram, TikTok, and YouTube CPM submissions require an official linked
// account. Keep this aligned with OFFICIAL_SOCIAL_CPM_REQUIRED_PLATFORMS.
const OFFICIAL_SOCIAL_CPM_ENFORCEMENT_ENABLED = true;
const OFFICIAL_SOCIAL_CPM_REQUIRED_PLATFORMS = new Set([
  'instagram',
  'tiktok',
  'youtube',
]);

export function requiresOfficialConnection(platform: string | null | undefined): boolean {
  return OFFICIAL_SOCIAL_CPM_ENFORCEMENT_ENABLED
    && OFFICIAL_SOCIAL_CPM_REQUIRED_PLATFORMS.has(String(platform || ''));
}
